<template>
    <transition appear name="fade-transition">
        <v-container fluid :class="classList">
            <v-row class="align-center">
                <v-col>
                    <slot v-if="findSlot('header')" name="header" />
                    <v-list v-else-if="icon || title || subtitle" class="app-section__header">
                        <v-list-item>
                            <v-list-item-avatar
                                v-if="icon"
                                color="primaryLight"
                                horizontal
                                :size="52"
                                class="align-self-start"
                            >
                                <v-icon color="primaryText" :size="26">{{ getIcon(icon) }}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title v-if="title || findSlot('title')" class="text-h5">
                                    <slot v-if="findSlot('title')" name="title" />
                                    <template v-else>{{ title }}</template>
                                </v-list-item-title>
                                <v-list-item-subtitle v-if="subtitle || findSlot('subtitle')" style="font-size: 1rem">
                                    <slot v-if="findSlot('subtitle')" name="subtitle" />
                                    <p v-else class="primaryText--text mb-0">{{ subtitle }}</p>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action v-if="findSlot('action')" class="app-section__action">
                                <slot name="action" />
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                    <slot />
                </v-col>
                <v-col v-if="findSlot('actions')" class="d-flex flex-row flex-grow-0 justify-end align-center">
                    <slot name="actions" />
                </v-col>
            </v-row>
        </v-container>
    </transition>
</template>

<script>
export default {
    name: 'AppSection',
    props: {
        icon: {
            type: String,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        subtitle: {
            type: String,
            default: null
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classList() {
            let classList = ['app-section'];

            if (this.clickable) {
                classList.push('app-section--clickable');
            }

            return classList.join(' ');
        }
    }
};
</script>

<style lang="scss">
.app-section {
    background: var(--v-background-base);
    transition: background 0.3s ease;

    &--show-on-hover {
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.3s ease;
    }

    &:hover {
        .app-section--show-on-hover {
            opacity: 1;
            visibility: visible;
        }
    }

    &--clickable {
        cursor: pointer;
        &:hover {
            background: var(--v-primaryLight-base);
        }
    }

    &--border-bottom {
        border-bottom: 1px solid var(--v-primaryLight-base);
    }

    &__header {
        background: none;
    }

    &__action {
        width: 100%;
        max-width: 100%;
        @include respond-above(md) {
            max-width: 50%;
        }
    }
}
</style>
